import {FBFieldWithPriceBaseOptions, PriceTypeEnum} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";
import {FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {IconOrImage} from "FormBuilder/Fields/Core/Interfaces/IconOrImage";
import {StoreDataType} from "shared/core/Store/StoreBase";


export class FBSwitchOptions extends FBFieldWithPriceBaseOptions{
    public Checked:boolean;

    public ShowQuantitySelector:boolean;

    @StoreDataType(Object)
    public CheckedIcon:IconOrImage;
    @StoreDataType(Object)
    public UnCheckedIcon:IconOrImage;

    public CheckColor:string;
    public UnCheckColor:string;


    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Type=FieldTypeEnum.Switch;
        this.Label='Switch';

        this.CheckColor='#080';
        this.UnCheckColor='#888';

        this.Checked=false;
        this.CheckedIcon=null;
        this.UnCheckedIcon=null;
        this.ShowQuantitySelector=false;
        this.QuantityPosition='bottom';
        this.QuantityMaximumValue=0;
        this.QuantityMinimumValue=0;
        this.QuantityDefaultValue='';
        this.QuantityPlaceholder='';
        this.QuantityLabel='Quantity';

        this.PriceType=PriceTypeEnum.none;
    }
}
